export default "__VITE_ASSET__DCjk5ruS__"